import { render, staticRenderFns } from "./StackedBarStats.vue?vue&type=template&id=efd4839e"
import script from "./StackedBarStats.vue?vue&type=script&lang=js"
export * from "./StackedBarStats.vue?vue&type=script&lang=js"
import style0 from "./StackedBarStats.vue?vue&type=style&index=0&id=efd4839e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports